import ExpressPlanCarouselItem from './ExpressPlanCarouselItem';

export default ExpressPlanCarouselItem;
